<template>
  <div class="sidebar-profile">
    <div class="sidebar-profile__background">


      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 478.38">
        <defs>
          <linearGradient id="Gradient_bez_nazwy_11" x1="498.37" y1="499.85" x2="-129.98" y2="-244.09" gradientTransform="matrix(-1, 0, 0, 1, 500, 0)" gradientUnits="userSpaceOnUse">
            <stop offset="0.19" stop-color="#900958" />
            <stop offset="0.96" stop-color="#ce596b" />
          </linearGradient>
        </defs>
        <path d="M500,.49v410.6c-36.3-13-77.56-21.47-118.83-15.62-84.14,11.91-168.28,83.4-252.42,83.4C83.68,478.87,38.61,458.35,0,433.8V.49Z" transform="translate(0 -0.49)" style="fill:url(#Gradient_bez_nazwy_11)" />
      </svg>

    </div>
    <div class="sidebar-profile__inner">

      <router-link
        v-if="isByVueRoute" :to="{name: 'members'}"
        class="sidebar-profile__logo"
      >
        <i class="demo-icon icon-logo-black"></i>
      </router-link>
      <a v-else class="sidebar-profile__logo" :href="zRoute('front.members.index')">
        <i class="demo-icon icon-logo-black"></i>
      </a>

      <router-link
        v-if="user && isByVueRoute" :to="{name: 'profile', params:{id: user.id}}"
        class="sidebar-profile__image"
      >
        <div
          class="avatar-single avatar-single--circle avatar-single--border-double"
          v-bind:style="{ 'background-image': 'url(' + user.web_avatar_url + '?h=300&w=200fit=crop)' }"
        >
          <div v-if="user.is_online" class="avatar-single__online-status"></div>
        </div>
      </router-link>
      <a v-else-if="user" class="sidebar-profile__image" :href="zRoute('front.profile.show', user.id)">
        <div
          class="avatar-single avatar-single--circle avatar-single--border-double"
          v-bind:style="{ 'background-image': 'url(' + user.web_avatar_url + '?h=300&w=200fit=crop)' }"
        >
          <div v-if="user.is_online" class="avatar-single__online-status"></div>
        </div>
      </a>

      <div class="sidebar-profile__data">
        <h5 v-if="user" class="sidebar-profile__name">{{ user.name }}</h5>
        <p v-if="user" class="sidebar-profile__loc">{{ user.full_address }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserCardComponent',
  data() {
    return {
      isByVueRoute: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  mounted() {
    if (this.$route.name) {
      this.isByVueRoute = true;
    }
  }
};
</script>

<style scoped>

</style>
